import * as yup from 'yup';

import parseDate from '../../helpers/dates/parseDate';
import dateFormatter from '../../helpers/formatters/dateFormatter';
import { DateTypeBase } from '../../types/baseTypes/DateTypeBase';
import { TypeContextEnum } from '../../types/properties/TypeContextEnum';
import Types from '../Types';
import { TYPE_GROUP_TIME } from '../constants';

/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use DateType from application-types instead.
 */
export class DateType extends DateTypeBase {
  group = TYPE_GROUP_TIME;

  name = 'Date';

  contexts = [
    TypeContextEnum.Block,
    TypeContextEnum.Content,
    TypeContextEnum.Data,
    TypeContextEnum.Properties,
  ];

  friendlyName = 'Date';

  formatter = (date: any, opts: any) =>
    dateFormatter(date, 'yyyy-MM-dd', opts?.timeZone);

  get example() {
    return new Date();
  }

  get default(): any {
    return new Date();
  }

  buildSchema() {
    return yup.date().nullable();
  }

  parseValue = (value: any) => parseDate(value);
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use Date from application-types instead.
 */
const definition = new DateType();

Types.addBaseType(definition);
export default definition;
